import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Plus } from "lucide-react";
import { FAQS } from "../../lib/faq";

export function FaqList({ testidPrefix = "faq" }) {
  return (
    <div className="divide-y divide-moss-100 border-y border-moss-100">
      {FAQS.map((item, i) => (
        <details
          key={item.q}
          className="group py-6"
          data-testid={`${testidPrefix}-item-${i + 1}`}
        >
          <summary
            className="flex cursor-pointer list-none items-start justify-between gap-6 text-left [&::-webkit-details-marker]:hidden"
            data-testid={`${testidPrefix}-question-${i + 1}`}
          >
            <h3 className="font-display text-lg sm:text-xl font-bold text-moss-950 leading-snug">
              {item.q}
            </h3>
            <span className="mt-0.5 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-sage-100 text-sage-800 transition-transform duration-300 group-open:rotate-45">
              <Plus className="h-4 w-4" strokeWidth={2.5} />
            </span>
          </summary>
          <p
            className="mt-3 max-w-3xl text-base text-moss-700 leading-relaxed"
            data-testid={`${testidPrefix}-answer-${i + 1}`}
          >
            {item.a}
          </p>
        </details>
      ))}
    </div>
  );
}

export default function FAQ() {
  return (
    <section id="faq" className="py-24 md:py-32 bg-white" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-4">
          <p className="text-[11px] font-semibold tracking-[0.18em] uppercase text-sage-700">
            FAQ
          </p>
          <h2 className="font-display mt-3 text-4xl sm:text-5xl font-extrabold text-moss-950 leading-[1.05] text-balance">
            Questions, answered.
          </h2>
          <Link
            to="/faq"
            className="mt-8 inline-flex items-center gap-2 text-base font-semibold text-moss-900 hover:text-sage-700 transition-colors group"
            data-testid="faq-see-all-link"
          >
            See all FAQs
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
        <div className="lg:col-span-8">
          <FaqList testidPrefix="home-faq" />
        </div>
      </div>
    </section>
  );
}
